import { Fragment, SyntheticEvent, useEffect, useState } from "react";
import { ServiceAccount, ServiceAccountType } from "../types";
import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, Box, Button, Dialog, DialogContent, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, LinearProgress, Radio, RadioGroup, TextField, Tooltip, Typography } from "@mui/material";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import HelpIcon from '@mui/icons-material/Help';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Paper from '@mui/material/Paper';
import { ServiceLine } from "../types";
import _ from "lodash";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import BaseModal from '../../../UserScreen/InventoryPage/InventorySettings/components/BaseModal/BaseModal';
import "./index.css";
import { bulkUpdateServiceLineOrganization, createServiceAccount, createV2ServiceAccount, extractThroughCredential, getAllServiceLinesByCredential, getServiceLineByCredentialParameters, createSubOrg } from "../slice";
import OrgSelection from "../../OrgSelection";
import ModalFooter from "../../../UserScreen/InventoryPage/InventorySettings/components/ModalFooter/ModalFooter";
import ServiceAccountClients from "./ServiceAccountClient";

interface ServiceAccountWorkflowDialogProps {
    authReducer: any;
    errorReducer: any;

    starlinkCloud: any;
    starlinkAdmin: any;
    serviceAccount: ServiceAccount | null;
    serviceLines: ServiceLine[];

    open: boolean;

    onClose: (refresh: boolean) => void;

    getAllServiceLinesByCredential: (parameters: getServiceLineByCredentialParameters, abortSignal: AbortSignal | undefined) => Promise<any>;
    createServiceAccount: (serviceAccount: ServiceAccount, abortSignal: AbortSignal | undefined) => Promise<any>;
    createV2ServiceAccount: (any, abortSignal: AbortSignal | undefined) => void;
    extractThroughCredential: (parameters: any, abortSignal: AbortSignal | undefined) => Promise<any>;
    bulkUpdateServiceLineOrganization: (parameters: any) => Promise<any>;
    createSubOrg: (parameters: any) => Promise<any>;
    v2ServiceAccount: any;
}

interface serviceAccountClient {
    id: number;
    clientId: string;
    clientSecret: string;
    accountNumber: string;
    selectedDp: any;
}

function ServiceAccountWorkflowDialog(props: ServiceAccountWorkflowDialogProps) {

    const { authReducer, errorReducer, starlinkAdmin, open, onClose, serviceLines,
        getAllServiceLinesByCredential, starlinkCloud, createServiceAccount, createV2ServiceAccount, extractThroughCredential, bulkUpdateServiceLineOrganization, createSubOrg, v2ServiceAccount } = props;

    const [serviceAccountType, setServiceAccountType] = useState<ServiceAccountType>('service_account_client');
    const [userName, setUserName] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [clientId, setClientId] = useState<string>('');
    const [clientSecret, setClientSecret] = useState<string>('');
    const [valid, setValid] = useState<boolean>(false);
    const [disableActions, setDisableActions] = useState<boolean>(false);
    const [activeStep, setActiveStep] = useState(0);
    const [selectedServiceLines, setSelectedServiceLine] = useState<ServiceLine[]>([])
    const [selectedDp, setSelectedDp] = useState<any>(null);
    const [requestAbortController, setRequestAbortController] = useState<AbortController | null>(null);
    const [credentialError, setCredentialError] = useState<string>('');
    const [validating, setValidating] = useState<boolean>(false);
    const [extractError, setExtractError] = useState<string>('');
    const [extracting, setExtracting] = useState<boolean>(false);
    const [newSubOrgNameValidationError, setNewSubOrgNameValidationError] = useState<string>('');
    const [iamServiceLines, setIAMServiceLines] = useState<any>([])
    const [makeNewSubOrg, setMakeNewSubOrg] = useState<boolean>(false);
    const [newSubOrgName, setNewSubOrgName] = useState<string>('');
    const [showMessage, setShowMessage] = useState(false);
    const [accountNumber, setAccountNumber] = useState<string>('');

    const [serviceAccountClients, setServiceAccountClients] = useState<serviceAccountClient[]>([{
            id: 0,
            clientId: "",
            clientSecret: "",
            accountNumber: "",
            selectedDp: { id: authReducer?.selectedOu?.id, name: authReducer?.selectedOu?.name }
        }])


    useEffect(() => {
        if (authReducer.fetchServiceLines.serviceLines) {
            let IAMServiceLines = authReducer.fetchServiceLines.serviceLines?.map((sl) => {
                return { serviceLineNumber: sl?.id, serviceLineName: sl?.name }
            })

            setIAMServiceLines(IAMServiceLines)
        }
    }, [authReducer.fetchServiceLines.serviceLines])

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleClose = (refresh: boolean = false) => (event: {}, reason: "backdropClick" | "escapeKeyDown"): void => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
        }
        requestAbortController?.abort();
        onClose(refresh);
    }

    const handleServiceAccountLink = async () => {
        setCredentialError('');
        let _serviceAccount = {
            dpId: authReducer.selectedOu.id,
            credentialDetails: serviceAccountClients.map(client => ({
                clientId: client.clientId,
                clientSecret: client.clientSecret,
                accountNumber: client.accountNumber,
                dpId: client.selectedDp.id
            }))
        }
        setValidating(true);
        let _abortController = new AbortController();
        setRequestAbortController(_abortController);
        createV2ServiceAccount(_serviceAccount, _abortController?.signal);
        setValidating(false);
        onClose(true);
        handleLinkAccountClose();
    }

    useEffect(() => {
        if (v2ServiceAccount) {
            // setShowMessage(true)
            // setActiveStep(1);
            // handleSubOrgStepInitialization();
        } else if (v2ServiceAccount?.response?.data?.message) {
            setCredentialError(v2ServiceAccount?.response?.data?.message);
        }
    },[v2ServiceAccount])

    const handleSubOrgStepInitialization = async () => {
        let _abortController = new AbortController();
        setRequestAbortController(_abortController);
        setDisableActions(true);
        setExtractError('');

        // setExtracting(true);
        // let res = await extractThroughCredential({ username: userName, clientId, skipUsage: true }, _abortController?.signal);
        // setExtracting(false);

        // if (res?.success) {
        //     // get service lines
        // } else if (res?.response?.data?.message) {
        //     setExtractError(res?.response?.data?.message);
        // } else {
        //     setExtractError('Failed to fetch service lines');
        // }

        if (!_.isEmpty(starlinkCloud.dpIds)) {
            await getAllServiceLinesByCredential({ username: userName, clientId }, _abortController?.signal);
        }
    }

    const handleChangeServiceAccountType = (event: React.ChangeEvent<HTMLInputElement>) => {
        setServiceAccountType((event.target as HTMLInputElement).value as ServiceAccountType);
        setCredentialError('');
        setUserName('');
        setPassword('');
        setClientId('');
        setClientSecret('');
    };

    const handleChangeUserName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserName(event.target.value);
        setCredentialError('');
    };

    const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
        setCredentialError('');
    };

    const handleChangeClientId = (event: React.ChangeEvent<HTMLInputElement>) => {
        setClientId(event.target.value);
        setCredentialError('');
    };

    const handleChangeClientSecret = (event: React.ChangeEvent<HTMLInputElement>) => {
        setClientSecret(event.target.value);
        setCredentialError('');
    };

    const handleChangeAccountNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAccountNumber(event.target.value)
    }

    const handleChangeSelectedServiceLines = (event: SyntheticEvent<Element, Event>, value: unknown, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<unknown> | undefined) => {

        if (reason === "selectOption" || reason === "removeOption") {
            if ((value as ServiceLine[]).find(option => option.serviceLineNumber === "all")) {
                return setSelectedServiceLine(serviceLines);
            } else {
                return setSelectedServiceLine(value as ServiceLine[]);
            }
        } else if (reason === "clear") {
            setSelectedServiceLine([]);
        }
    }

    const handleChangeDp = (ou: any) => {
        setSelectedDp(ou)
    }

    const handleNewSubOrgInit = () => {
        setMakeNewSubOrg(true);
    }

    const handleNewSubOrgCreationCancel = () => {
        setMakeNewSubOrg(false);
        setNewSubOrgNameValidationError('');
    }

    const handleChangeNewSubOrgName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewSubOrgName(event.target.value);
        if (event.target.value.match(/[^A-Za-z0-9\s]/)) {
            setNewSubOrgNameValidationError('Only alphanumeric characters are allowed');
        } else {
            setNewSubOrgNameValidationError('');
        }
    }

    const handleNewSubOrgSave = async () => {
        setDisableActions(true);
        setExtractError('');

        if (!_.isEmpty(selectedDp)) {
            let res = await createSubOrg({
                DPName: newSubOrgName,
                DPFullName: newSubOrgName,
                parentName: selectedDp.name
            })
            let _level = selectedDp.level + 1;
            if (res?.status === 1) {
                setSelectedDp({
                    id: res?.data?.data?.dpId,
                    name: newSubOrgName,
                    level: _level,
                    hasChildren: false,
                })
            } else if (res?.response?.data?.message) {
                setExtractError(res?.response?.data?.message);
            } else {
                setExtractError('Failed to create Sub-Organization');
            }
        }
        setDisableActions(false);
        setMakeNewSubOrg(false);
    }

    const handleAssignServiceLine = async () => {
        setDisableActions(true);
        setExtractError('');
        let res = await bulkUpdateServiceLineOrganization({
            dpId: selectedDp?.id,
            serviceLineNumbers: selectedServiceLines.map(serviceLine => serviceLine.serviceLineNumber),
        });

        if (res?.success) {
            onClose(true);
        } else if (res?.response?.data?.message) {
            setExtractError(res?.response?.data?.message);
        } else {
            setExtractError('Failed to assign Service Lines to Sub-Organization');
        }
        setRequestAbortController(null);
        setDisableActions(false);
    }


    useEffect(() => {
        if (open) {
            setRequestAbortController(new AbortController());
            setActiveStep(0);
            setDisableActions(false);
            setServiceAccountType('service_account_client');
            setUserName('');
            setPassword('');
            setClientId('');
            setClientSecret('');
            setNewSubOrgName('');
            setMakeNewSubOrg(false);
            setSelectedDp(authReducer?.selectedOu)
            setSelectedServiceLine([]);
            setValidating(false);
            setCredentialError('');
            setExtracting(false);
            setExtractError('');
        }
    }, [open]);

    useEffect(() => {
        setValid(
            activeStep === 0 ?
                (serviceAccountType === 'service_account_client' ? !!clientId && !!clientSecret : !!userName && !!password) :
                (selectedServiceLines.length > 0 && !!selectedDp)
        );
    }, [serviceAccountType, userName, password, clientId, clientSecret, activeStep, selectedServiceLines, selectedDp]);

    useEffect(() => {
        setDisableActions(
            starlinkAdmin.creatingServiceAccount ||
            starlinkAdmin.updatingServiceAccount ||
            starlinkAdmin.deletingServiceAccount
        );
    }, [starlinkAdmin.creatingServiceAccount, starlinkAdmin.updatingServiceAccount, starlinkAdmin.deletingServiceAccount]);

    const handleLinkAccountClose = () => {
        setServiceAccountClients([{
            id: 0,
            clientId: "",
            clientSecret: "",
            accountNumber: "",
            selectedDp: null
        }])
        onClose(false); 
        setShowMessage(false);
    }

    const hasNoDuplicateServiceAccounts = () => {
        const uniqueSet = new Set<string>();
        for (const client of serviceAccountClients) {
            const key = `${client.clientId.trim().toLowerCase()}|` +
                        `${client.clientSecret.trim().toLowerCase()}|` +
                        `${client.accountNumber.trim().toLowerCase()}|` +
                        `${client.selectedDp?.id ?? ""}`;

            if (uniqueSet.has(key)) {
            return false;
            }
            uniqueSet.add(key);
        }
        return true;
};
    
    const areAllClientsValid = () => {
        if(serviceAccountClients.length == 0 || !hasNoDuplicateServiceAccounts()) return false
        return serviceAccountClients.every(client =>
            client.clientId.trim() !== "" &&
            client.clientSecret.trim() !== "" &&
            client.accountNumber.trim() !== "" && 
            client.selectedDp !== null
        );
    };

    return (
        <>
            <BaseModal showOnlineOffline={false} width='840px' height="400px" open={open} onClose={() => { onClose(false); setShowMessage(false) }} title={`Link Service Account`} showOnlineStatus={true} onlineStatusText={""} showRefreshIcon={false} showSyncStatus={false}>
                <DialogContent className="modal-content-wrapper">
                    <Box
                        className="modal-body"
                        style={{ flexDirection: 'row' }}
                    >
                        <Box className="modal-content">
                            <Box className="modal-tab-panel-starlink">
                                {/* <Grid display={"flex"} alignItems={"center"} classes={{ root: 'starlink--base--mtb_07x' }}>
                                    <Typography style={{ width: "200px" }}>Select Organization</Typography>

                                    <OrgSelection value={selectedDp} onChange={handleChangeDp} disabled={disableActions} />
                                </Grid> */}
                                <Grid classes={{ root: 'starlink--base--mtb_07x' }}>
                                    <FormControl disabled={disableActions}>
                                                <Grid marginBottom={4} className='displayClients'>
                                                    Service Account Client
                                                    <Tooltip classes={{ tooltip: 'starlink--tooltip' }} title={<Grid>
                                                        <Typography component="div" className="starlink--base--font_08x starlink--base--padding_05x">
                                                            <p>To set up API access, log into your Starlink account home page.</p>
                                                            <p>In the section named "Your Service Accounts" select the "+" in the top right corner to create a new service account.</p>
                                                            <p>If you do not see the section "Your Service Accounts" reach out to your account manager to inquire about access.</p>
                                                        </Typography>
                                                    </Grid>}>
                                                        <HelpIcon fontSize="small" />
                                                    </Tooltip>
                                                </Grid>     
                                    </FormControl>
                                    {
                                        serviceAccountType === 'service_account_client' ?
                                            <ServiceAccountClients serviceAccountClients={serviceAccountClients} setServiceAccountClients={setServiceAccountClients} disableActions={disableActions}/>
                                            : null}
                                </Grid>
                                {!hasNoDuplicateServiceAccounts() && <Grid>
                                    <FormHelperText error={credentialError?.length > 0}>
                                        <Typography component="div" className="starlink--base--text_center starlink--base--font_08x warningMsg">
                                            {'Duplicate accounts with same credentials added'}
                                        </Typography>
                                    </FormHelperText>

                                </Grid>}
                                <Grid>
                                    <FormHelperText error={credentialError?.length > 0}>
                                        <Typography component="div" className="starlink--base--text_center starlink--base--font_08x">
                                            {credentialError}
                                        </Typography>
                                    </FormHelperText>

                                </Grid>

                            </Box>
                            {<ModalFooter
                                onClose={ handleLinkAccountClose }
                                onSave={handleServiceAccountLink}
                                // onSave={()=>{setShowMessage(true)}}
                                cancelText={"Cancel"}
                                saveText={"Add"}
                                disableSave={!areAllClientsValid()}
                                // !valid || disableActions
                            />}
                        </Box>
                    </Box>
                </DialogContent>
            </BaseModal>
        </>

    )
}

const mapStateToProps = (state: any) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    starlinkCloud: state.starlinkCloud,
    starlinkAdmin: state.starlinkAdmin,
    serviceLines: state.starlinkAdmin.allServiceLines,
    v2ServiceAccount: state.starlinkAdmin?.v2ServiceAccount
});

export default withRouter(
    connect(mapStateToProps, {
        getAllServiceLinesByCredential,
        createServiceAccount,
        createV2ServiceAccount,
        extractThroughCredential,
        bulkUpdateServiceLineOrganization,
        createSubOrg
    })(ServiceAccountWorkflowDialog)
);